module.exports = __webpack_public_path__ + "img/pic02.12001023.jpg";